import React, { useState } from "react";
import "./Modal.css";

const holidayData = {
  2026: [
    { day: "Saturday, January 3, 2026", name: "Birthday of Hazrat Ali" },
    { day: "Thursday, January 15, 2026", name: "Makar Sankranti / Pongal" },
    { day: "Thursday, February 19, 2026", name: "Chhatrapati Shivaji Maharaj Jayanti" },
    { day: "Monday, March 2, 2026", name: "Holika Dahan" },
    { day: "Tuesday, March 3, 2026", name: "Holi" },
    { day: "Wednesday, March 4, 2026", name: "Holi" },
    { day: "Thursday, March 19, 2026", name: "Gudhi Padwa" },
    { day: "Saturday, March 21, 2026", name: "Ramzan-Id (Id-Ul-Fitr)" },
    { day: "Thursday, March 26, 2026", name: "Ram Navami" },
    { day: "Tuesday, March 31, 2026", name: "Mahavir Jayanti" },
    { day: "Wednesday, April 1, 2026", name: "Bank Year Closing" },
    { day: "Tuesday, April 14, 2026", name: "Dr. Babasaheb Ambedkar Jayanti" },
    { day: "Friday, May 1, 2026", name: "Labour Day / Maharashtra Day" },
    { day: "Wednesday, May 27, 2026", name: "Eid-ul-Adha (Bakri Eid)" },
    { day: "Thursday, May 28, 2026", name: "Bakri ID" },
    { day: "Friday, June 26, 2026", name: "Muharram" },
    { day: "Wednesday, August 26, 2026", name: "Id-E-Milad" },
    { day: "Friday, August 28, 2026", name: "Raksha Bandhan" },
    { day: "Friday, September 4, 2026", name: "Janmashtami" },
    { day: "Monday, September 14, 2026", name: "Ganesh Chaturthi" },
    { day: "Monday, November 9, 2026", name: "Diwali" },
    { day: "Tuesday, November 10, 2026", name: "Diwali (Balipratipada)" }
  ]
};

const Modal = ({ setIsModal }) => {
  const [activeYear, setActiveYear] = useState("2026");

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h3>Settlement Holiday List</h3>

        <div className="dash-year-btn-container">
          {Object.keys(holidayData).map((year) => (
            <button
              key={year}
              className={`year-btn ${activeYear === year ? "active" : ""}`}
              onClick={() => setActiveYear(year)}
            >
              {year}
            </button>
          ))}
        </div>

        <div className="table-main-div">
          <table className="table-user-management">
            <thead className="table-user-header">
              <tr>
                <td>
                  <p className="user-table-head">Day</p>
                </td>
                <td>
                  <p className="user-table-head">Name</p>
                </td>
              </tr>
            </thead>
            <tbody>
              {holidayData[activeYear].map((holiday, index) => (
                <tr key={index} className="table-user-data">
                  <td>
                    <p className="user-table-head">{holiday.day}</p>
                  </td>
                  <td>
                    <p className="user-table-head">{holiday.name}</p>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="table-footer">
          <p>
            <span className="asterisk">*</span> All <b>Sundays</b> and the 2nd & 4th{" "}
            <b>Saturdays</b> are bank holidays.
          </p>
          <p>
            <span className="asterisk">*</span> State gazetted holidays, if any,
            will be communicated accordingly.
          </p>
        </div>

        <button className="holiday-close-btn" onClick={() => setIsModal(false)}>
          Close
        </button>
      </div>
    </div>
  );
};

export default Modal;
